import React from 'react';
import ConfirmModal from '../Elements/UI/ConfirmModal';

const Conformationdeleteform = ({ show, onClose, onConfirm }) => {
  return (
    <ConfirmModal
      show={show}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete form?"
      message="The form and its submissions will be removed. This can't be undone."
    />
  );
};

export default Conformationdeleteform;
